import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { motion } from 'framer-motion'

export const DirectionContent = styled(motion(Box))<{
    address: string
    addressMob: string
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: ${({ address }) => {
            if (address === 'row') return 'row'
            if (address === 'row-reverse') return 'row-reverse'
            return 'column'
        }};
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const OverCard = styled(motion(Box))<{
    background: string
}>`
    background: url(${(props) => props.background}) no-repeat center/cover;
    width: 248px;
    height: 272px;
    margin-bottom: 31px;
    border-radius: 15px;
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 188px;
        height: 202px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 248px;
        height: 272px;
    }
`
export const Refer = styled.a``
export const OverSpan = styled.span`
    position: absolute;
    background-size: cover;
    background-position: center center;
    top: 0;
    left: 0;
    border-radius: 15px;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    background-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
    );
`

export const ImageSection = styled(Box)`
    width: 48%;
    height: 90%;
    z-index: 20;
`
export const Section = styled(Box)`
    width: 90%;
    height: 90%;
    display: flex;
    z-index: 20;
    flex-direction: column;
    align-items: center;
    justify-content: start;
`
export const Image = styled.img`
    width: 100%;
    height: 58%;
`
export const TypographySection = styled(Box)`
    width: 100%;
    height: 40%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 40%;
        justify-content: space-evenly;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
        height: 42%;
        justify-content: center;
    }
`
export const ContentSection = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 12px;
    text-align: center;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 14px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 19px;
    }
`
